import type { TRuleWithTheme } from '@ackee/fela';

import { BackgroundMode } from '../PixelatedBackgroundWrapper/constants';

import spaceshipSrc from '../../../../static/images/hp/our-services/spaceship.png';

type Props = { backgroundMode?: BackgroundMode };

export const container: TRuleWithTheme = () => ({
    position: 'relative',
});

export const articlesWrapper: TRuleWithTheme = () => ({ flexDirection: 'column' });

export const sectionTitle: TRuleWithTheme<Props> = ({ theme, backgroundMode }) => ({
    color: backgroundMode === BackgroundMode.Dark ? theme.colors.white : theme.colors.black,

    marginBottom: '7rem',
});

export const noPaddingBottom: TRuleWithTheme = () => ({
    paddingBottom: '0',
    marginBottom: -100,
    zIndex: 1,
    position: 'relative',

    tabletLarge: {
        paddingBottom: '70',
    },
});

export const linkWrapper: TRuleWithTheme = () => ({
    justifyContent: 'center',
    overflow: 'visible',

    tabletLarge: {
        marginTop: '11rem',
    },
});

export const link: TRuleWithTheme = () => ({
    textDecoration: 'none',
});

export const linkText: TRuleWithTheme = ({ theme }) => ({
    display: 'inline',
    fontSize: '1.25rem',
    lineHeight: '3.6875rem',
    color: theme.colors.cyan,
    borderBottom: `2px solid ${theme.colors.blue}`,
    textDecoration: 'none',
    textTransform: 'unset',
});

export const contentContainer: TRuleWithTheme<Props> = ({ backgroundMode, theme }) => ({
    position: 'relative',
    overflow: 'visible',

    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    gap: '2.5rem',
    flexWrap: 'wrap',

    '&::before': {
        content: '""',

        position: 'absolute',
        top: '10%',
        right: '5%',
        width: '100%',
        aspectRatio: '5/3',

        backgroundImage: backgroundMode === BackgroundMode.Dark ? `url(${spaceshipSrc})` : 'none',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '40%',

        animationDuration: '1.25s, 1.25s',
        animationDelay: '0s, 1.25s',
        animationIterationCount: '1, infinite',
        animationDirection: 'normal, alternate',
        animationTimingFunction: 'ease-in-out',

        zIndex: -1,

        animationName:
            backgroundMode === BackgroundMode.Dark
                ? [
                      {
                          '0%': { backgroundPosition: 'left -30% bottom 0', opacity: 0 },
                          '100%': { backgroundPosition: 'right 15% top 0', opacity: 1 },
                      },
                      {
                          '0%': { backgroundPosition: 'right 15% top 0' },
                          '100%': { backgroundPosition: 'right 17% top 3%' },
                      },
                  ]
                : 'none',
    },
});

export const extendArticlesContainer: TRuleWithTheme = () => ({
    tabletLarge: {
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: '4rem',
    },
});

export const leftColumn: TRuleWithTheme = () => ({
    maxWidth: '100%',

    tabletLarge: {
        width: '33.333%',
        maxWidth: '25.25rem',
    },
});

export const imgBefore: TRuleWithTheme = () => ({
    position: 'absolute',
    right: 0,
    top: -60,
});

export const imgAfter: TRuleWithTheme = () => ({
    position: 'absolute',
    left: 0,
    bottom: 0,
});

export const carouselImgAfter: TRuleWithTheme = () => ({
    position: 'absolute',
    right: 0,
    bottom: 60,
});
